export const hexToDecimal = hex => parseInt(hex, 16); 
export const formatNumber = number => new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(number)